import styled from 'styled-components';

import LazyLoadedImg from 'core/components/LazyLoadedImg';

// Import icons by individual modules for better code splitting
import Calendar from 'core/icons/Calendar';
import OrderNow from 'core/icons/OrderNow';

import { getColor, StyleVars, typeScale } from 'core/utils';

export const CalendarIcon = styled(Calendar)`
	width: 16px;
	height: 16px;
	margin-right: 12px;
	line-height: 1.38;
`;

export const ImagePlaceholder = styled(OrderNow)`
	min-width: 50%;
	height: auto;
	margin: 0 auto 32px;

	@media (min-width: 1201px) {
		width: 170px;
		height: 170px;
		margin: 0 48px 0 0;
		min-width: auto;
	}
`;

export const OrderNowIcon = styled(OrderNow)`
	width: 80px;
	height: 80px;
	margin-left: 8px;
	margin-top: -24px;
	margin-bottom: 16px;
	padding: 2px;
	background-color: white;
	border-radius: 50%;

	@media (min-width: 768px) {
		width: 100px;
		height: 100px;
		margin-top: -50px;
	}

	@media (min-width: 1201px) {
		margin-bottom: 0;
	}

	@media (min-width: 1280px) {
		width: 125px;
		height: 125px;
		position: absolute;
		top: 16px;
		left: -60px;
		margin: 0;
	}
`;

export const Wrapper = styled.section`
	padding: 16px 0;
	margin-top: 16px;
`;

export const FlexContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 32px 0;
	border-bottom: 1px solid ${getColor('alto')};

	&:first-of-type {
		padding-top: 0;
	}

	&:last-of-type {
		border-bottom: 0 none;
	}

	@media (min-width: 1201px) {
		flex-direction: row;
		align-items: center;
	}

	@media(max-width: ${StyleVars.screenSm}) {
		padding-bottom: ${typeScale(1)};
	}
`;

export const Frame = styled.div`
	cursor: pointer;
	position: relative;

	@media (min-width: 1201px) {
		flex: 1;
		max-width: 400px;
		margin-right: 32px;
	}
`;

export const MainImage = styled(LazyLoadedImg)`
	display: flex;
	border-radius: 8px;

	@media (min-width: 1201px) {
		max-width: 100%;
		min-width: 324px;
		min-height: 324px;
		object-fit: cover;
	}
`;

export const HighlightText = styled.p`
	line-height: 1.38;
	letter-spacing: 0.2px;
	font-size: 14px;
	font-weight: 600;
	color: ${getColor('lavender')};

	@media(max-width: ${StyleVars.screenSm}) {
		margin-bottom: ${typeScale(1)};
	}
`;
